import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import Email from './svg/email'

const Headshots = ({ slice }) => {
  var grid = 'md:grid-cols-2 max-w-screen-lg'
  if (slice.items.length === 3) {
    grid = 'md:grid-cols-3 max-w-screen-xl'
  }
  if (slice.items.length === 4) {
    grid = 'md:grid-cols-2 lg:grid-cols-4 max-w-screen-xl'
  }
  return (
    <section className='component-headshots mx-auto w-full max-w-screen-xl px-6 py-8 md:py-10'>
      <div className='prose prose-lg mb-10 max-w-none text-center'>
        <PrismicRichText field={slice.primary.title.richText} />
      </div>

      <ul className={`grid grid-cols-2 gap-6 lg:grid-cols-3 ${grid}`}>
        {slice.items.map((person, index) => {
          return (
            <li key={`person-${person.name}`} className='flex flex-col bg-white'>
              {person.image.gatsbyImageData && (
                <div className='aspect-w-3 aspect-h-2 relative overflow-hidden'>
                  <div className='absolute inset-0 h-1/2 bg-brand-blue-dark mix-blend-multiply'></div>
                  <GatsbyImage image={person.image.gatsbyImageData} alt={person.image.alt || ''} className='object-cover' />
                </div>
              )}
              <div className='m-4 space-y-3 md:m-6'>
                <div>
                  <p className='font-medium text-brand-blue'>{person.role}</p>
                  <h3 className='text-2xl text-brand-blue'>{person.name}</h3>
                  {person.email && (
                    <a href={`mailto:${person.email}`} className='flex flex-wrap items-center text-brand-orange hover:text-stone-600'>
                      <Email className='mr-1 mt-0.5 h-3 w-3' />
                      <div className='tw-hidden text-sm lowercase'>{person.email}</div>
                      <div className='lg:hidden'>Email</div>
                    </a>
                  )}
                </div>
                {person.bio.text && (
                  <div className='prose prose-sm md:prose-base'>
                    <PrismicRichText field={person.bio.richText} className='text-stone-500' />
                  </div>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

Headshots.propTypes = {
  slice: PropTypes.object.isRequired
}

export default Headshots
